import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY

export const supabase = createClient(supabaseUrl, supabaseKey)

// Adaptateur storage compatible avec window.storage de l'artifact
// Toutes les données sont stockées dans la table "storage" avec user_id
export const storage = {
  async get(key) {
    try {
      const { data, error } = await supabase
        .from('storage')
        .select('value')
        .eq('key', key)
        .maybeSingle()
      if (error || !data) return null
      return { key, value: data.value }
    } catch(e) {
      return null
    }
  },

  // Rend { key, value } si la ligne est RELUE après écriture, null sinon.
  //
  // ⚠️ GARDE « RIEN À ÉCRIRE » (vécu, journal des factures figé du 02/06 au
  // 01/10/2026) : `JSON.stringify(undefined)` vaut `undefined`, pas une chaîne.
  // La ligne partait sans valeur, la base la refusait (colonne `value` non
  // nulle) et ce refus finissait en console, invisible. On refuse donc AVANT
  // le réseau toute valeur qui ne donne pas une chaîne — l'appelant reçoit
  // null, comme pour tout autre échec, et doit le montrer.
  async set(key, value) {
    const texte = typeof value === 'string' ? value : JSON.stringify(value)
    if (typeof texte !== 'string') {
      console.error('Storage set refusé : rien à écrire pour', key)
      return null
    }
    try {
      // `.select('key')` : on exige de relire la ligne écrite. Une écriture
      // sans erreur mais sans ligne rendue n'est pas une écriture prouvée.
      const { data, error } = await supabase
        .from('storage')
        .upsert({ key, value: texte }, { onConflict: 'key' })
        .select('key')
      if (error) throw error
      if (!Array.isArray(data) || data.length !== 1) {
        throw new Error(`écriture non relue (${Array.isArray(data) ? data.length : 'aucune'} ligne)`)
      }
      return { key, value }
    } catch(e) {
      console.error('Storage set error:', e)
      return null
    }
  },

  async delete(key) {
    try {
      const { error } = await supabase
        .from('storage')
        .delete()
        .eq('key', key)
      if (error) throw error
      return { key, deleted: true }
    } catch(e) {
      return null
    }
  }
}
